import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { useParams } from 'react-router-dom';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import SuspenseWithLoader from '../SuspenseWithLoader';
import PDPPlaceholder from '../PDP/PDPPlaceholder';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';

const specialCategories = {
  'mid-century-furniture': true,
  'small-space-furniture': true,
  modern: true,
  new: true,
};

const CategoryPage = loadable(
  () => import('../CategoryPage'),
  isNewConsumerApp
    ? { loading: ProductListingPagePlaceholder }
    : {
        fallback: <div />,
      }
);

const PDP = loadable(
  () => import('../PDP'),
  isNewConsumerApp
    ? { loading: PDPPlaceholder }
    : {
        fallback: <PDPPlaceholder />,
      }
);

const ProductAndCategory = props => {
  const { category: categoryFromPath, slug: slugFromPath } = useParams();

  const {
    category: categoryOverride,
    slug: slugOverride,
    isAdmin,
    productOptionsPromise,
  } = props;

  const category = categoryOverride || categoryFromPath;
  const slug = slugOverride || slugFromPath;

  // Keep the PDP instance stable while deep-link query params change.
  // The PDP reads query params from router state, so the full tree does not
  // need to remount when a user changes fabrics or other options.
  const pdpKey = slug;

  if (isAdmin) {
    return (
      <AdminPlaceholder>
        ProductAndCategory Component Placeholder for Variant Builder. <br />
        The component will display the product page correctly in Consumer
      </AdminPlaceholder>
    );
  }

  if (specialCategories[category]) {
    const categoryPageSlug = `${category}/${slug}`;

    return (
      <SuspenseWithLoader
        fallback={<ProductListingPagePlaceholder />}
        key={categoryPageSlug}
      >
        <CategoryPage slug={categoryPageSlug} key={categoryPageSlug} />
      </SuspenseWithLoader>
    );
  }

  return (
    <SuspenseWithLoader fallback={<PDPPlaceholder />} key={pdpKey}>
      <PDP key={pdpKey} productOptionsPromise={productOptionsPromise} />
    </SuspenseWithLoader>
  );
};

ProductAndCategory.propTypes = {
  isAdmin: PropTypes.bool,
  category: PropTypes.string,
  slug: PropTypes.string,
  productOptionsPromise: PropTypes.object,
};

export default ProductAndCategory;
